export default __webpack_public_path__ + "static/media/include_5_male@3x.9b8b603f.jpg";